module.exports = __webpack_public_path__ + "static/media/icon--facebank.c0b439c6.png";